"use client";
import { LoadingOutlined } from "@ant-design/icons";
import { Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import { adjustTracking } from "@/services/adjust";
import "./styles.scss";

export interface IProps {
  open: boolean;
  setOpen: (v: boolean) => void;
}

export const DownloadModal = (props: IProps) => {
  const { open, setOpen } = props;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // 设置 15 秒超时
    const timeoutId = setTimeout(() => {
      if (isLoading) {
        setIsLoading(false);
        // message.error("加载超时，请刷新重试");
      }
    }, 15000);

    return () => clearTimeout(timeoutId);
  }, [isLoading]);

  useEffect(() => {
    if (open) {
      localStorage.setItem("downloadModalOpen", "true");
      // Track download event when modal opens
      adjustTracking.trackDownload({ source: 'modal', timestamp: new Date().toISOString() });
    }
  }, [open]);

  return (
    <Modal
      title="Apply to Become Fellou's Early Adopter"
      open={open}
      width={930}
      closeIcon={
        <div className={"modal-close-btn"}>
          <i className="icon iconfont icon-a-close-line4"></i>
        </div>
      }
      onCancel={() => setOpen(false)}
      className={"download-modal-warp"}
      footer={null}
    >
      <div className="download-modal">
        {isLoading && (
          <div className="loading-wrapper">
            <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
          </div>
        )}
        <iframe
          src="https://tally.so/r/mDbZBR?source=website"
          style={{
            width: "100%",
            height: "600px", // 可以根据需要调整
            border: "none", // 移除iframe边框
            display: isLoading ? "none" : "block",
          }}
          title="Download Form"
          allow="camera; microphone; autoplay; encrypted-media;"
          frameBorder="0"
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </Modal>
  );
};
